module.exports = __webpack_public_path__ + "img/avatar-s-11.613b2258.jpg";